import * as React from 'react';
import DataTable from "react-data-table-component";
import {Button} from 'reactstrap';
//import {deselectPosition, selectPosition} from "../job/FinishedJobComponent";

interface ICardProps {
  data: any[];
  columns: any[];
  selected: any[];
  inMutant: any[];
  showSelectAll?: false;

  setSelectedRows: (selectedRows: any[]) => void;

  addToCustomMutant: (selectedRows: any[]) => void;
}
function Table(props:ICardProps) {

  const handleChange = ({ selectedRows }) => {
    const prevSelectedRows = props.selected ?? [];
    if (selectedRows.length === 0 && prevSelectedRows.length === 0) {
      return;
    }
    if (selectedRows.length === prevSelectedRows.length) {
      const same = selectedRows.every(r => prevSelectedRows.includes(r));
      if (same) {
        return;
      }
    }
    props.setSelectedRows(selectedRows);
  };

  const rowSelectCritera = (row) => {
   return props.selected.includes(row);
  };


  const addToMutant = (row) => {
    props.addToCustomMutant(row);
        console.log('clicked',row);
    };

  return (
    <>

      <DataTable
        columns={[...props.columns, 
                  {
                    name: "Add to Design",
                    cell: (row) => <Button style={{width: "70%",}} onClick={() => addToMutant(row)} disabled= {props.inMutant.some(m => m.position === row.position && m.chain === row.chain)} >+</Button>,
                    ignoreRowClick: true,
                    button: true,
                  }
        ]}
        data={props.data}
        selectableRows
        onSelectedRowsChange={handleChange}
        selectableRowSelected={rowSelectCritera}
        pagination
        highlightOnHover={true}
      />
    </>
  );
    
}

export default Table;

